import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {HomeComponent} from './home/home.component';

const routes: Routes = [
  { path: 'Apply-visa', loadChildren: './applyurgetvisa/applyvisa.module#ApplyVisaModule' },  
  { path: 'About-Us', loadChildren: './aboutus/aboutus.module#AboutUsModule' },
  { path: 'Contact-Us', loadChildren: './contactus/contactus.module#ContactUsModule' },
  //{ path: 'document', loadChildren: './documentrequired/document.module#DocumentRequiredModule' },
  //{ path: 'eligible-countries', loadChildren: './eligiblecontries/eligiblecountries.module#EligibleCountriesModule' },
  { path: 'Sri-Lanka-Fee', loadChildren: './evisa-fee/evisa-fee.module#EvisaFeeModule' },
  //{ path: 'faq', loadChildren: './faq/faq.module#FaqModule' },
 // { path: 'instruction', loadChildren: './instructions/instruction.module#InstructionModule' }, 
  //{ path: 'payments', loadChildren: './payments-guidlines/payment-guidlines.module#PaymentGuidleinsModule' },
  { path: 'Privacy-Policy', loadChildren: './privacypolicy/privacy.module#PrivacyModule' },
  { path: 'Refund-Policy', loadChildren: './refund-policy/refund-policy.module#RefundPolicyModule' },
  { path: 'Terms-and-conditions', loadChildren: './termcondition/term.module#TermModule' },
  { path: 'services', loadChildren: './services/services.module#ServicesModule' },
  {path: '', component: HomeComponent, pathMatch:'full'},
{ path: '**', redirectTo: '', pathMatch:'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// C:/Users/user/Desktop/rohini_india/angular/Srilanka-eta.org.lk/src/app/app-routing.module.ts